import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  page: 1,
  perPage: 10,
  total: 0,
  isLoading: false,
  isError: false,
  error: "",

  isUpdating: false,
  isUpdateSuccess: false,

  isAdding: false,
  isAddSuccess: false,

  filters: {
    status: 1,
    companyName: "",
    ownerEmail: "null",
  },
};

const companyListSlice = createSlice({
  name: "companyList",
  initialState: initialState,
  reducers: {
    getCompanyList: (state) => {
      state.isLoading = true;
    },
    getCompanyListSuccess: (state, action) => {
      state.data = action.payload.rows;
      state.page = +action.payload.page;
      state.perPage = +action.payload.perPage;
      state.count = action.payload.count;
      state.isLoading = false;
      state.isError = false;
      state.error = "";
    },
    getCompanyListFailed: (state, action) => {
      state.data = [];
      state.isLoading = false;
      state.isError = true;
      state.error = action.payload;
    },

    updateCompanyStatus: (state) => {
      state.isUpdating = true;
    },
    updateCompanyStatusSuccess: (state, action) => {
      state.data = state.data.map((item) => {
        if (item.id === action.payload.companyId) {
          return { ...item, status: action.payload.status };
        }
        return item;
      });
      state.isUpdating = false;
    },
    updateCompanyStatusFailed: (state) => {
      state.isUpdating = false;
    },

    updateCompanyPaymentMode: (state) => {
      state.isUpdating = true;
    },
    updateCompanyPaymentModeSuccess: (state, action) => {
      state.data = state.data.map((item) => {
        if (item.id === action.payload.companyId) {
          return { ...item, paymentMode: action.payload.paymentMode };
        }
        return item;
      });
      state.isUpdating = false;
      state.isUpdateSuccess = true;
    },
    updateCompanyPaymentModeFailed: (state) => {
      state.isUpdating = false;
    },
    updateCompanyPaymentModeReset: (state) => {
      state.isUpdateSuccess = false;
    },

    updateCompanyInfo: (state) => {
      state.isUpdating = true;
      state.isUpdateSuccess = false;
    },
    updateCompanyInfoSuccess: (state, action) => {
      state.data = state.data.map((item) => {
        if (item.id === action.payload.companyId) {
          return {
            ...item,
            name: action.payload.name,
            slug: action.payload.slug,
            enableWhitelevel: action.payload.enableWhitelevel,
            enableTopupRecharge: action.payload.enableTopupRecharge,
          };
        }
        return item;
      });
      state.isUpdating = false;
      state.isUpdateSuccess = true;
    },
    updateCompanyInfoFailed: (state) => {
      state.isUpdating = false;
      state.isUpdateSuccess = false;
    },
    updateCompanyInfoReset: (state) => {
      state.isUpdateSuccess = false;
    },

    updateCompanyBilling: (state) => {
      state.isUpdating = true;
      state.isUpdateSuccess = false;
    },
    updateCompanyBillingSuccess: (state, action) => {
      state.data = state.data.map((item) => {
        if (item.id === action.payload.companyId) {
          return { ...item, ...action.payload };
        }
        return item;
      });
      state.isUpdating = false;
      state.isUpdateSuccess = true;
    },
    updateCompanyBillingFailed: (state) => {
      state.isUpdating = false;
      state.isUpdateSuccess = false;
    },
    updateCompanyBillingReset: (state) => {
      state.isUpdateSuccess = false;
    },

    updateCompanyListFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },

    createCompanyAccount: (state) => {
      state.isAdding = true;
      state.isAddSuccess = false;
    },
    createCompanyAccountSuccess: (state) => {
      state.isAdding = false;
      state.isAddSuccess = true;
    },
    createCompanyAccountFailed: (state) => {
      state.isAdding = false;
      state.isAddSuccess = false;
    },
    createCompanyAccountReset: (state) => {
      state.isAdding = false;
      state.isAddSuccess = false;
    },
  },
});

export const {
  getCompanyList,
  getCompanyListSuccess,
  getCompanyListFailed,

  updateCompanyStatus,
  updateCompanyStatusSuccess,
  updateCompanyStatusFailed,

  updateCompanyPaymentMode,
  updateCompanyPaymentModeSuccess,
  updateCompanyPaymentModeFailed,
  updateCompanyPaymentModeReset,

  updateCompanyInfo,
  updateCompanyInfoSuccess,
  updateCompanyInfoFailed,
  updateCompanyInfoReset,

  updateCompanyBilling,
  updateCompanyBillingSuccess,
  updateCompanyBillingFailed,
  updateCompanyBillingReset,

  updateCompanyListFilters,

  createCompanyAccount,
  createCompanyAccountSuccess,
  createCompanyAccountFailed,
  createCompanyAccountReset,
} = companyListSlice.actions;

export default companyListSlice.reducer;
